export type TypedError<N extends string> = Omit<Error, 'name'> & { name: N };

export function typedError<N extends string>(name: N, message: string) {
  const error = new Error(message);
  error.name = name;
  return error as TypedError<N>;
}
